// Generated from src/assets/Check.svg
import React, { PureComponent } from "react";

interface ISVGWarningIconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  flex: "0 0 auto",
  cursor: "pointer"
};

export default class SVGWarningIcon extends PureComponent<
  ISVGWarningIconProps,
  {}
> {
  render() {
    const props = this.props;
    const { size } = props;
    return (
      <svg
        {...props}
        preserveAspectRatio="xMidYMid meet"
        fontSize={size || 32}
        style={style}
        viewBox="0 0 57 50"
        width="43"
        height="37"
      >
        <defs>
          <linearGradient
            id="linear0"
            gradientUnits="userSpaceOnUse"
            x1="0.294506"
            y1="0.155897"
            x2="0.871523"
            y2="0.906234"
            gradientTransform="matrix(364.018298,0,0,323.302813,1.997738,0.353281)"
          >
            <stop
              offset="0"
              stopColor="rgb(100%,63.137255%,63.137255%)"
              stopOpacity="1"
            />
            <stop
              offset="1"
              stopColor="rgb(70.588235%,11.764706%,11.764706%)"
              stopOpacity="1"
            />
          </linearGradient>
          <linearGradient
            id="linear1"
            gradientUnits="userSpaceOnUse"
            x1="0.27927"
            y1="0.126479"
            x2="0.899107"
            y2="0.940962"
            gradientTransform="matrix(360.250411,0,0,315.379219,3.034539,5.147812)"
          >
            <stop
              offset="0"
              stopColor="rgb(100%,63.137255%,63.137255%)"
              stopOpacity="1"
            />
            <stop
              offset="1"
              stopColor="rgb(70.588235%,11.764706%,11.764706%)"
              stopOpacity="1"
            />
          </linearGradient>
          <linearGradient
            id="linear2"
            gradientUnits="userSpaceOnUse"
            x1="0.27927"
            y1="0.126479"
            x2="0.899107"
            y2="0.940962"
            gradientTransform="matrix(360.250411,0,0,315.379219,3.034539,5.147812)"
          >
            <stop
              offset="0"
              stopColor="rgb(100%,63.137255%,63.137255%)"
              stopOpacity="1"
            />
            <stop
              offset="1"
              stopColor="rgb(70.588235%,11.764706%,11.764706%)"
              stopOpacity="1"
            />
          </linearGradient>
          <filter
            id="alpha"
            filterUnits="objectBoundingBox"
            x="0%"
            y="0%"
            width="100%"
            height="100%"
          >
            <feColorMatrix
              type="matrix"
              in="SourceGraphic"
              values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
            />
          </filter>
          <mask id="mask0">
            <g filter="url(#alpha)">
              <rect
                x="0"
                y="0"
                width="57"
                height="50"
                fill="rgb(0%,0%,0%)"
                fillOpacity="0.658824"
                stroke="none"
              />
            </g>
          </mask>
          <image
            id="image10"
            width="57"
            height="50"
            xlinkHref="data:image/png;base64,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"
          />
        </defs>
        <g id="surface1">
          <use xlinkHref="#image6" />
          <path
            fillRule="nonzero"
            fill="url(#linear0)"
            strokeWidth="6.25"
            strokeLinecap="butt"
            strokeLinejoin="miter"
            stroke="rgb(0%,0%,0%)"
            strokeOpacity="1"
            strokeMiterlimit="4"
            d="M 183.817229 3.482344 C 179.619449 3.709453 175.800987 6.031016 173.676809 9.69 L 4.703536 301.222734 C 2.478207 305.083594 2.478207 309.852891 4.703536 313.738984 C 6.928865 317.599844 11.050781 319.997109 15.501439 319.997109 L 352.436472 320.527031 C 356.912418 320.527031 361.034334 318.155 363.284951 314.294141 C 365.535567 310.433281 365.535567 305.663984 363.310238 301.803125 L 195.297903 9.715234 C 192.946135 5.6525 188.520765 3.255234 183.817229 3.482344 Z M 184.424137 40.955391 L 330.840666 295.494531 L 37.198396 295.040312 Z M 184.424137 40.955391"
            transform="matrix(0.154472,0,0,0.154799,0,0)"
          />
          <path
            fillRule="nonzero"
            fill="url(#linear1)"
            strokeWidth="25"
            strokeLinecap="butt"
            strokeLinejoin="round"
            stroke="url(#linear2)"
            strokeMiterlimit="4"
            d="M 352.46176 308.036016 L 15.526727 307.506094 L 184.474712 15.973359 Z M 352.46176 308.036016 "
            transform="matrix(0.154472,0,0,0.154799,0,0)"
          />
          <use xlinkHref="#image10" mask="url(#mask0)" />
          <path
            stroke="none"
            fillRule="nonzero"
            fill="rgb(100%,100%,100%)"
            fillOpacity="1"
            d="M 28.40625 12.742188 C 28.015625 12.761719 27.65625 12.980469 27.460938 13.320312 L 11.703125 40.566406 C 11.496094 40.925781 11.496094 41.371094 11.703125 41.734375 C 11.910156 42.09375 12.292969 42.320312 12.710938 42.320312 L 44.132812 42.367188 C 44.546875 42.371094 44.933594 42.148438 45.144531 41.785156 C 45.351562 41.425781 45.351562 40.980469 45.144531 40.617188 L 29.476562 13.324219 C 29.257812 12.945312 28.84375 12.71875 28.40625 12.742188 Z M 28.40625 12.742188 "
          />
          <path
            stroke="none"
            fillRule="nonzero"
            fill="rgb(0%,0%,0%)"
            fillOpacity="1"
            d="M 28.789062 32.765625 L 28.058594 32.765625 C 27.984375 31.488281 27.730469 29.960938 27.304688 28.183594 L 26.4375 24.554688 C 25.917969 22.378906 25.660156 20.824219 25.660156 19.882812 C 25.660156 17.984375 26.574219 17.035156 28.410156 17.035156 C 29.214844 17.035156 29.878906 17.300781 30.402344 17.824219 C 30.925781 18.347656 31.1875 19.019531 31.1875 19.832031 C 31.1875 20.695312 30.910156 22.269531 30.359375 24.554688 L 29.480469 28.183594 C 29.167969 29.457031 28.9375 30.984375 28.789062 32.765625 Z M 28.449219 35.144531 C 30.023438 35.15625 31.027344 36.34375 31.136719 37.855469 C 31.132812 39.433594 29.957031 40.441406 28.449219 40.546875 C 26.871094 40.542969 25.867188 39.367188 25.757812 37.855469 C 25.789062 36.273438 26.929688 35.253906 28.449219 35.144531 Z M 28.449219 35.144531 "
          />
        </g>
      </svg>
    );
  }
}
